import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '../store'
import {
  $getQuetyString,
  host,
  appid,
  $inWeChat
} from '@/common/common.js'

import {
  getOpenId,
  setCode,
  getCode,
  removeCode
} from '../utils/storage'
Vue.use(VueRouter)

/*
  注意事项：
  meta对象中若 auth 为 true 则此页面必须有有效的token才能访问，否则去/login
  meta对象中若 binding 为 true 则此页面在登陆成功后判断没有绑定学生信息会跳转到绑定页面
*/
const routes = [{
    path: '/',
    redirect: "/home",
    meta: {
      title: "七天学堂"
    }
  },
  {
    path: '/download',
    name: 'download',
    meta: {
      title: '立即下载'
    },
    component: () => import('@/views/Download/index')

  },
  {
    path: '/home',
    name: 'home',
    meta: {
      title: '七天学堂',
      binding: true,
      auth: true
    },
    component: () => import('@/views/Home/index')

  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录'
    },
    component: () => import('@/views/Login/index')

  },
  {
    path: '/school',
    name: 'school',
    component: () => import('@/views/School/index'),
    meta: {
      title: '选择学校',
    }
  },
  {
    path: '/grade',
    name: 'grade',
    component: () => import('@/views/Grade/index'),
    meta: {
      title: '选择年级',
    }
  },
  {
    path: '/binding',
    name: 'binding',
    component: () => import('@/views/Binding/index'),
    meta: {
      title: '用户绑定',
      keepAlive: true,
    }
  },
  {
    path: '/vip',
    name: 'vip',
    component: () => import('@/views/Vip/index'),
    meta: {
      title: '会员购买',
    }
  },
  {
    path: '/course',
    name: 'course',
    component: () => import('@/views/Course/index'),
    meta: {
      title: '课程',
    }
  },
  {
    path: '/liveCourse',
    name: 'liveCourse',
    component: () => import('@/views/LiveCourse/index'),
    meta: {
      title: '直播课程',
    }
  },
  {
    path: '/h5',
    name: 'h5',
    component: () => import('@/views/H5/index'),
    meta: {
      title: '七天学堂',
      keepAlive: true,
    }
  },
  {
    path: '/szonebind',
    name: 'szonebind',
    meta: {
      title: '考试通知授权',
      binding: false
    },
    component: () => import('@/views/Szonebind/index')

  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) document.title = to.meta.title
  /*
    总共分两种环境，微信环境，非微信环境
    1:微信环境：
      先授权，授权后拿到Code去取token, 若接口报错说明code有问题重新去授权
      若接口没报错分且有token时直接加载页面，若无token说明没绑定手机号，此时去看页面是否需要登陆才能查看（即meta.auth）对应调整去login
    2:非微信环境
      去看页面是否需要登陆才能查看（即meta.auth）对应调整去login
  */
  if ($getQuetyString('from')) {
   // 分享可能出现 https://szone-public.septnet.cn/?from=singlemessage#/course?courseGuid=ea3659b7-05bc-4cf1-b8f7-9519e5ba738b
   let query = $.param(to.query || {})
   window.location.href = host + to.path + (query ? ('?' + query) : '')
  // 变成 https://szone-public.septnet.cn/#/course?courseGuid=ea3659b7-05bc-4cf1-b8f7-9519e5ba738b
  }
  if ($inWeChat) {
    let code = $getQuetyString('code')
    if (code) {
      /*
        微信回调内部的code
        https://szone-public.septnet.cn/?code=021EuYZv3xdiJU2Qwg2w3p8IAv2EuYZz&state=#/vip?params=1
      */
      let query = $.param(to.query || {})
      setCode(code)
      window.location.href = host + to.path + (query ? ('?' + query) : '')
      // https://szone-public.septnet.cn/#/vip?params=1&&code=11 // code不会再被 getQuetyString 取到
    } else if (getCode()) {
      // url参数有code ,请求token
      // 先移除
      let code = getCode()
      removeCode()
      store.dispatch('act_getcodeToken', code).then(() => {
        verifyPathAuth(store, to, next)
      }).catch(() => {
        reAuthorize(next)
      })
    } else if (!store.state.openid) {
      // 没有code，说明是分享或者直接输入网址的， 此时去授权
      // 这里通openId去判断是否授权过，故openId再退出登录的时候不能删除，否则会无法退出登录，因为会重新授权重新取token
      reAuthorize(next)
    } else {
      // 有openid说明授权过了 可能有token 可能没token，去判断页面
      verifyPathAuth(store, to, next)
    }
  } else {
    // 非微信环境页面
    verifyPathAuth(store, to, next)
  }
})

// 重新获取微信授权code
function reAuthorize(next) {
  // 微信里需要授权的
  let url = window.location.href
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(url)}&response_type=code&scope=snsapi_base#wechat_redirect`
}

// 验证页面是否需要登陆
function verifyPathAuth(store, to, next) {
  if (store.state.token) {
    // 有token，先获取用户信息，完事了再走下一步
    if (!store.state.userInfo) {
      store.commit("cmtUserInfo",null);
      userinfo(store, to, next, to.meta.binding)
    } else {
      next()
    }
  } else {
    // 没有token看页面是否需要登陆，需要登陆就去login, 通过from传递需要返回的页面（防止router.back返回不了）
    if (!to.meta.auth) {
      // 不需要登陆的页面
      next()
    } else {
      router.replace({
        path: '/login',
        query: {
          from: encodeURIComponent(to.path)
        }
      })
    }
  }
}

// 获取用户信息接口
function userinfo(store, to, next, needBind) {
  store.dispatch('act_getuserInfo').then((res) => {
    if (res.data.schoolGuid && res.data.studentName) {
      next()
    } else if ((!res.data.schoolGuid || !res.data.studentName )&& needBind) {
      // 页面需要绑定学生信息才能展示，此时去绑定页面
      next('/binding')
    } else {
      next()
    }
  }).catch(() => {
    // 接口回调错误，比如挤掉线， 此时已经清除登陆信息了，去判断该页面是否需要登陆
    store.dispatch('act_logout')
    verifyPathAuth(store, to, next)
  })
}

export default router
